var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"update-notification-wrapper"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"update-notification-content"},[_c('span',[_vm._v("Aplicación actualizada correctamente ✓")])])
}]

export { render, staticRenderFns }